/**
 * Initial requirement
 * - Tally need to refresh price, distance, transitTime when the following factor change
 *  - vehicle type
 *  - time type
 *  - locations
 *  - optimize route
 *  - return discount
 */
import React from 'react'
import PropTypes from 'prop-types'
import { Utils } from 'utils/Utils'
import { TallyUtils } from 'utils/booking/TallyUtils'
import { CPOD, FULL_DAY, LONG_HAUL, NEW_GEN_POD, NOW, SCHEDULE } from 'constants/bookingConstants'
import _ from 'lodash'
import I18n from 'i18n/i18n'
import CommonUtils from 'utils/common'
import pinpointService from 'utils/pinpointService'
import * as Sentry from '@sentry/react'
import { VISITOR_ID } from 'utils/visitorIdManager'

const LONG_HYPHEN = '&mdash;'
class TallyBar extends React.PureComponent {
  componentDidUpdate(prevProps) {
    const {
      toggleTallyBar,
      timeType,
      currentStep,
      booking = {},
      quickChoiceID,
      pickupTime,
      selectedVehicleTypeID,
      checkLocations,
      quickChoiceSelected,
    } = this.props
    const { trackingData } = booking
    const { price, distance, transitTime } = this.props
    const { price: prevPrice, distance: prevDistance, transitTime: prevTransitTime } = prevProps
    const { price: priceShow, distance: distanceShow, transitTime: transitTimeShow } = this.isShowTally()
    if ((price !== prevPrice || prevPrice) && (distance !== prevDistance || timeType === FULL_DAY)) {
      toggleTallyBar()
    }
    if (
      (currentStep === 1 || currentStep === 2) &&
      price !== null &&
      !isNaN(price) &&
      distance !== null &&
      !CommonUtils.isMultiple() &&
      (price !== prevPrice || distance !== prevDistance || transitTime !== prevTransitTime)
    ) {
      const priceSend = priceShow === LONG_HYPHEN ? 0 : price
      const transitTimeSend = transitTimeShow === LONG_HYPHEN ? 0 : Number.parseInt(transitTime / 60, 10)
      const distanceSend = distanceShow === LONG_HYPHEN ? 0 : distance
      const timeTypePayload = (isMoE = false) => {
        let timeTypeText = ''
        switch (timeType) {
          case SCHEDULE:
            timeTypeText = 'schedule'
            break
          case FULL_DAY:
            timeTypeText = isMoE ? 'full day' : 'full_day'
            break
          case LONG_HAUL:
            timeTypeText = 'fpr'
            break
          case NOW:
            timeTypeText = 'now'
            break

          default:
            break
        }
        return timeTypeText
      }

      const convertToUTCMilliseconds = (dateTimeString) => {
        const date = new Date(dateTimeString)
        if (isNaN(date.getTime())) {
          return null
        }
        const utcMilliseconds = date.getTime()
        return utcMilliseconds
      }

      CommonUtils.moengageTrackEvent('Tally Info', {
        'Total Fees': priceSend,
        Distance: distanceSend,
        Duration: transitTimeSend,
        'Booking Step': `Step ${currentStep}`,
        'Surge AI': Boolean(trackingData?.surge_ai),
        Surge: trackingData?.surcharges_fees_tally,
        'Special Adjustment': trackingData?.surcharges_adjustments,
        'Distance Fee': trackingData?.distance_fees,
        'Added Location Fee': trackingData?.way_point_fees,
        'Vehicle Type ID': selectedVehicleTypeID,
        'Time Type': quickChoiceID !== 0 && quickChoiceID !== null ? null : timeTypePayload(true),
        'Quick Choice Schedule Time':
          quickChoiceID === 0 || quickChoiceID === null ? null : quickChoiceSelected?.schedule_time,
        'Quick Choice Time Type': quickChoiceID === 0 || quickChoiceID === null ? null : timeTypePayload(true),
        'Pickup Time': convertToUTCMilliseconds(pickupTime),
        'SF POD': checkLocations?.cod_pod === CPOD && booking?.cod_pod_fees ? true : false,
        'EM POD': checkLocations?.cod_pod === NEW_GEN_POD && booking?.cod_pod_fees ? true : false,
      })
      pinpointService.trackEvent('tally_info', {
        total_fees: priceSend,
        distance: distanceSend,
        duration: transitTimeSend,
        booking_step: `step_${currentStep}`,
        time_type: quickChoiceID !== 0 && quickChoiceID !== null ? null : timeTypePayload(),
        vehicle_type_id: selectedVehicleTypeID,
        pickup_time: convertToUTCMilliseconds(pickupTime),
        quick_choice_schedule_time:
          quickChoiceID === 0 || quickChoiceID === null ? null : quickChoiceSelected?.schedule_time,
        quick_choice_time_type: quickChoiceID === 0 || quickChoiceID === null ? null : timeTypePayload(),
        sf_pod: checkLocations?.cod_pod === CPOD && booking?.cod_pod_fees ? 'true' : 'false',
        em_pod: checkLocations?.cod_pod === NEW_GEN_POD && booking?.cod_pod_fees ? 'true' : 'false',
        surge_ai: trackingData?.surge_ai ? 'true' : 'false',
        surge: trackingData?.surcharges_fees_tally,
        special_adjustment: trackingData?.surcharges_adjustments,
        distance_fee: trackingData?.distance_fees,
        added_location_fee: trackingData?.way_point_fees,
      })

      // Debugging for distance_fees - DLVR-56963
      const visitorId = sessionStorage.getItem(VISITOR_ID) || ''
      if (!trackingData?.distance_fees) {
        Sentry.captureException('DEBUG_DLVR_PINPOINT_TALLY_INFO', {
          contexts: {
            currentStep,
            trackingData,
            distance_fees: String(trackingData?.distance_fees),
            time_type: timeTypePayload(),
            quick_choice_id: quickChoiceID,
            surge_ai: trackingData?.surge_ai ? true : false,
            visitor_id: visitorId,
          },
        })
      }
    }
  }

  isShowTally = () => {
    const { waitingAnimation, showTallyData } = this.props
    let { price, distance, transitTime } = this.props
    transitTime = transitTime !== null ? transitTime : LONG_HYPHEN

    const hasData = price !== null && distance !== null && transitTime !== null
    const showTally = waitingAnimation ? showTallyData : hasData
    price = +price === 0 ? LONG_HYPHEN : price
    distance = +distance === 0 ? LONG_HYPHEN : distance
    return { showTally, price, distance, transitTime }
  }

  render() {
    const {
      // price = LONG_HYPHEN,
      // distance = LONG_HYPHEN,
      // transitTime = LONG_HYPHEN,
      countryLanguage,
      currency,
      visibilitySetting,
    } = this.props
    // we always show long hyphen if transitTime is null. if it for the case of transit time setting is disabled

    const { showTally, price, distance, transitTime } = this.isShowTally()

    const priceText = _.isFinite(+price) ? Utils.formatFee(+price, countryLanguage, currency) : price
    const distanceText = _.isFinite(+distance)
      ? `${Utils.formatDistance(TallyUtils.roundUp(distance), countryLanguage)} ${I18n.t('webapp.booking.km')}`
      : distance
    const transitTimeText = _.isFinite(+transitTime) ? Utils.convertSecondsToTimeString(+transitTime) : transitTime

    /* eslint-disable react/no-danger */
    return (
      <div className="tally-bar-container mt15 mr10 ml10">
        {showTally && (
          <div className="tally-bar Radius-Default pt5 pr5 pb5 pl5 flex flex-row">
            {visibilitySetting.price && priceText ? (
              <div className="tally-bar-row-item flex flex-column" id="tally-summary-price-value">
                <div className="value" dangerouslySetInnerHTML={{ __html: priceText }} />
                <div className="text">{I18n.t('webapp.tally_bar.price')}</div>
              </div>
            ) : null}
            {visibilitySetting.distance && distanceText ? (
              <div className="tally-bar-row-item flex flex-column" id="tally-summary-distance-value">
                <div className="value" dangerouslySetInnerHTML={{ __html: distanceText }} />
                <div className="text">{I18n.t('webapp.tally_bar.distance')}</div>
              </div>
            ) : null}
            {visibilitySetting.transitTime && transitTimeText ? (
              <div className="tally-bar-row-item flex flex-column" id="tally-summary-transit-time-value">
                <div className="value" dangerouslySetInnerHTML={{ __html: transitTimeText }} />
                <div className="text">{I18n.t('webapp.tally_bar.transit')}</div>
              </div>
            ) : null}
          </div>
        )}
      </div>
    )
  }
}

TallyBar.propTypes = {
  price: PropTypes.number,
  distance: PropTypes.number,
  transitTime: PropTypes.number,
  countryLanguage: PropTypes.string.isRequired,
  currency: PropTypes.string.isRequired,
  visibilitySetting: PropTypes.shape({}),
  quickChoiceSelected: PropTypes.shape({}),
  priceLabel: PropTypes.string,
  showTallyData: PropTypes.bool,
  toggleTallyBar: PropTypes.func,
  waitingAnimation: PropTypes.bool,
  timeType: PropTypes.string,
  checkLocations: PropTypes.shape({}),
  quickChoiceID: PropTypes.number,
  selectedVehicleTypeID: PropTypes.number,
  pickupTime: PropTypes.string,
  tallyTracking: PropTypes.shape({}),
}

TallyBar.defaultProps = {
  price: null,
  distance: null,
  transitTime: null,
  visibilitySetting: {
    price: true,
    distance: true,
    transitTime: true,
  },
  showTallyData: true,
  toggleTallyBar: () => undefined,
  waitingAnimation: false,
  timeType: '',
}

export default TallyBar
